
export function logEntry(message, color) {

    const dictObject = {
        message: message,
        color: color
    }

    return dictObject
}


// WEBPACK FOOTER //
// ./src/tools/logEntryFile.js